/**
 * Collection UX
 * 1) Size filter + In Stock in My Size (client-side on color/variant cards)
 *    Variant grids show 1 card per color, so Shopify products_count ≠ card count.
 *    We filter cards to the selected size and sync "X Results" to visible cards.
 * 2) Mobile sticky filter bar
 * 3) Filter drawer click guard
 */
(function () {
  'use strict';

  var STORAGE_INSTOCK = 'ymi_in_stock_my_size';
  /** URL query key — shareable like a filter: ?ymi_instock=1 */
  var INSTOCK_PARAM = 'ymi_instock';
  var bar = null;
  var spacer = null;
  var fixed = false;
  var naturalTop = 0;
  var syncTimer = null;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getBoundingClientRect().height > 0;
  }

  function isDrawerOpen() {
    return document.documentElement.classList.contains('js-drawer-open-collection-filters') ||
      document.body.classList.contains('js-drawer-open-collection-filters');
  }

  function normalizeSize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function getInstockFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var v = params.get(INSTOCK_PARAM);
      if (v == null || v === '') return null;
      return v === '1' || v === 'true' || v === 'on';
    } catch (e) {
      return null;
    }
  }

  function isInstockEnabled() {
    // URL is source of truth for shareable links; storage covers brief AJAX gaps
    var fromUrl = getInstockFromUrl();
    if (fromUrl !== null) return fromUrl;
    try { return localStorage.getItem(STORAGE_INSTOCK) === '1'; } catch (e) { return false; }
  }

  /** Keep hidden inputs on filter forms so theme AJAX FormData preserves the param. */
  function syncInstockFormInputs(on) {
    qsa('.filter-form').forEach(function (form) {
      var input = form.querySelector('input[name="' + INSTOCK_PARAM + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = INSTOCK_PARAM;
        input.setAttribute('data-ymi-instock-url', '1');
        form.appendChild(input);
      }
      if (on) {
        input.value = '1';
        input.disabled = false;
      } else {
        input.value = '';
        input.disabled = true;
      }
    });
  }

  function writeInstockUrl(on) {
    try {
      var url = new URL(window.location.href);
      if (on) {
        url.searchParams.set(INSTOCK_PARAM, '1');
      } else {
        url.searchParams.delete(INSTOCK_PARAM);
      }
      var qs = url.searchParams.toString();
      var next = url.pathname + (qs ? '?' + qs : '') + url.hash;
      var cur = window.location.pathname + window.location.search + window.location.hash;
      if (next !== cur) {
        window.history.replaceState(window.history.state || {}, '', next);
      }
    } catch (e) { /* ignore */ }
    syncInstockFormInputs(on);
  }

  function saveInstock(on) {
    try { localStorage.setItem(STORAGE_INSTOCK, on ? '1' : '0'); } catch (e) { /* ignore */ }
    writeInstockUrl(!!on);
  }

  function isSizeParam(name) {
    if (!name) return false;
    var n = String(name).toLowerCase();
    if (n.indexOf('availability') !== -1) return false;
    if (n.indexOf('size-group') !== -1 || n.indexOf('size_group') !== -1 || n.indexOf('sizegroup') !== -1) {
      return false;
    }
    return n.indexOf('filter.v.option.') === 0 && n.indexOf('size') !== -1;
  }

  function getActiveSizeFilters() {
    var sizes = [];
    var seen = {};

    function addSize(value) {
      var v = String(value == null ? '' : value).trim();
      if (!v) return;
      var key = normalizeSize(v);
      if (seen[key]) return;
      seen[key] = true;
      sizes.push(v);
    }

    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (value, key) {
        if (isSizeParam(key)) addSize(value);
      });
    } catch (e) { /* ignore */ }

    qsa('.filter-form input.tag__input:checked').forEach(function (input) {
      if (isSizeParam(input.name)) addSize(input.value);
    });

    qsa('.ymi-filter-chips .tag--remove a, .col-top-filter .tag--remove a').forEach(function (a) {
      var label = (a.getAttribute('data-filter-label') || '').toLowerCase();
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (label === 'size' || /^size\s*:/i.test(text)) {
        var parts = text.split(':');
        if (parts.length > 1) {
          addSize(parts.slice(1).join(':').replace(/\s*remove\s*$/i, '').trim());
        }
      }
    });

    return sizes;
  }

  function getProductGridRoot() {
    return (
      qs('#CollectionAjaxContent .collection-grid__wrapper .js-infinite-wrapper') ||
      qs('#CollectionAjaxContent .js-infinite-wrapper') ||
      qs('.collection-grid__wrapper .js-infinite-wrapper') ||
      qs('#CollectionAjaxContent .collection-grid__wrapper')
    );
  }

  function getProductCards() {
    var root = getProductGridRoot();
    if (root) return qsa('.grid-product', root);
    return qsa('#CollectionAjaxContent .grid-product');
  }

  function clearClientHides() {
    getProductCards().forEach(function (card) {
      card.classList.remove('ymi-hidden-by-mysize');
    });
  }

  /**
   * Float grids use nth-of-type clearfixes. display:none items still count,
   * which leaves holes. Pack visible cards first so rows stay even.
   */
  function compactFilteredGrid() {
    var root = getProductGridRoot();
    if (!root) return;

    var cards = qsa('.grid-product', root);
    if (!cards.length) return;

    var visible = [];
    var hidden = [];
    cards.forEach(function (card) {
      if (card.classList.contains('ymi-hidden-by-mysize')) hidden.push(card);
      else visible.push(card);
    });

    var loadMore = qs('.js-load-more', root);
    var loadMoreIcon = qs('.load-more__icon', root.parentNode) || qs('.load-more__icon');

    visible.forEach(function (card) { root.appendChild(card); });
    hidden.forEach(function (card) { root.appendChild(card); });
    if (loadMore) root.appendChild(loadMore);
    if (loadMoreIcon && loadMoreIcon.parentNode === root) root.appendChild(loadMoreIcon);
  }

  /**
   * Sync "X Results" with visible product cards when size filtering hides cards.
   * When no size filter: keep server-rendered count (avoids first-page flash e.g. 35→55).
   */
  function updateResultsCount() {
    var hasSizeFilter = getActiveSizeFilters().length > 0;
    var countEls = qsa(
      '.filtered-product-count, [data-ymi-results-count], .collection-filter__item--count'
    );

    // No client size filter → restore / keep accurate server count
    if (!hasSizeFilter) {
      countEls.forEach(function (el) {
        if (el.classList.contains('collection-filter__item--count') && !el.textContent.match(/\d/)) {
          return;
        }
        var serverCount = el.getAttribute('data-ymi-server-count');
        if (serverCount == null || serverCount === '') return;
        var n = parseInt(serverCount, 10);
        if (isNaN(n)) return;
        el.textContent = n + (n === 1 ? ' Result' : ' Results');
        el.setAttribute('data-ymi-results-count', String(n));
        el.classList.remove('ymi-count-pending');
      });
      document.documentElement.classList.remove('ymi-count-pending');
      return;
    }

    var cards = getProductCards();
    var visible = 0;
    var seen = {};

    cards.forEach(function (card) {
      if (card.classList.contains('ymi-hidden-by-mysize')) return;
      // Prefer variant/product id so we never double-count
      var id = card.getAttribute('data-product-id') || card.getAttribute('data-product-handle') || '';
      var key = id ? String(id) : ('node:' + visible + ':' + (card.textContent || '').slice(0, 24));
      if (seen[key]) return;
      seen[key] = true;
      visible += 1;
    });

    var label = visible + (visible === 1 ? ' Result' : ' Results');

    countEls.forEach(function (el) {
      // Keep sort/filter chrome; only rewrite count-like nodes
      if (el.classList.contains('collection-filter__item--count') && !el.textContent.match(/\d/)) {
        return;
      }
      el.textContent = label;
      el.setAttribute('data-ymi-results-count', String(visible));
      el.classList.remove('ymi-count-pending');
    });

    document.documentElement.classList.remove('ymi-count-pending');

    // Keep the selected Size option's "(N)" in sync with visible cards
    qsa('.size-container li.tag--active label, .size-container li.tag--active .tag__checkbox-wrapper').forEach(function (labelEl) {
      var textEl = qs('.tag__text:not(.hide)', labelEl);
      if (!textEl) return;
      var parent = textEl.parentNode;
      if (!parent) return;
      Array.prototype.slice.call(parent.childNodes).forEach(function (node) {
        if (node === textEl) return;
        if (node.nodeType === 3) node.textContent = '';
      });
      var countEl = qs('[data-ymi-size-count]', parent);
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.setAttribute('data-ymi-size-count', '1');
        parent.appendChild(document.createTextNode(' '));
        parent.appendChild(countEl);
      }
      countEl.textContent = '(' + visible + ')';
    });
  }

  /**
   * Hide color/product cards that do not offer the selected size.
   * - Size only → use data-all-sizes (fall back to data-available-sizes)
   * - In Stock on → use data-available-sizes only
   * Cards with no size data stay visible (avoid empty grids).
   */
  function applyClientSizeFilter(enable, sizes, instockOnly) {
    if (!enable) {
      clearClientHides();
      compactFilteredGrid();
      updateResultsCount();
      return;
    }

    var sizeList = sizes || getActiveSizeFilters();
    var norms = sizeList.map(normalizeSize);
    if (!norms.length) {
      clearClientHides();
      compactFilteredGrid();
      updateResultsCount();
      return;
    }

    getProductCards().forEach(function (card) {
      var available = (card.getAttribute('data-available-sizes') || '').trim();
      var allSizes = (card.getAttribute('data-all-sizes') || '').trim();
      var source = instockOnly
        ? (available || allSizes)
        : (allSizes || available);

      if (!source) {
        card.classList.remove('ymi-hidden-by-mysize');
        return;
      }

      var match = source.split('|').filter(Boolean).some(function (s) {
        return norms.indexOf(normalizeSize(s)) !== -1;
      });
      card.classList.toggle('ymi-hidden-by-mysize', !match);
    });

    compactFilteredGrid();
    updateResultsCount();
  }

  /** Remove leftover availability params from older In Stock AJAX logic. */
  function stripStaleAvailability() {
    var dirty = false;

    qsa('.filter-form input[name*="availability"]').forEach(function (input) {
      if (input.checked) {
        input.checked = false;
        dirty = true;
      }
    });

    try {
      var url = new URL(window.location.href);
      var keys = [];
      url.searchParams.forEach(function (_value, key) {
        if (String(key).toLowerCase().indexOf('filter.v.availability') === 0) {
          keys.push(key);
        }
      });
      if (keys.length) {
        keys.forEach(function (k) { url.searchParams.delete(k); });
        window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
        dirty = true;
      }
    } catch (e) { /* ignore */ }

    return dirty;
  }

  function syncInstockUI() {
    var sizes = getActiveSizeFilters();
    var hasSizeFilter = sizes.length > 0;
    var instock = isInstockEnabled();

    if (!hasSizeFilter) {
      if (instock || getInstockFromUrl() !== null) {
        saveInstock(false);
      } else {
        syncInstockFormInputs(false);
      }
      instock = false;
      clearClientHides();
    } else {
      // Keep URL + form inputs aligned (survives filter AJAX URL rewrites)
      writeInstockUrl(instock);
    }

    document.documentElement.classList.toggle('ymi-size-filter-active', hasSizeFilter);
    document.body.classList.toggle('ymi-size-filter-active', hasSizeFilter);

    qsa('[data-ymi-my-size], .ymi-my-size-bar').forEach(function (wrap) {
      wrap.classList.toggle('ymi-my-size--size-active', hasSizeFilter);
      wrap.classList.toggle('ymi-my-size--instock-on', hasSizeFilter && instock);
      if (hasSizeFilter) {
        wrap.hidden = false;
        wrap.style.removeProperty('display');
      } else {
        wrap.hidden = true;
        wrap.style.display = 'none';
      }

      var toggle = qs('[data-ymi-instock-toggle]', wrap);
      if (toggle) {
        toggle.disabled = !hasSizeFilter;
        toggle.checked = hasSizeFilter && instock;
      }
    });

    // Always filter cards when a size is selected (variant grids show all colors otherwise)
    applyClientSizeFilter(hasSizeFilter, sizes, hasSizeFilter && instock);
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncInstockUI, delay || 0);
  }

  function initInstockInMySize() {
    qsa(
      '.ymi-my-size__row, .ymi-my-size__label, .ymi-my-size__select, .ymi-my-size__change, [data-ymi-my-size-select], [data-ymi-my-size-change]'
    ).forEach(function (el) {
      el.style.display = 'none';
    });

    stripStaleAvailability();
    syncInstockUI();

    document.addEventListener('change', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-ymi-instock-toggle]');
      if (!toggle && e.target.matches && e.target.matches('[data-ymi-instock-toggle]')) {
        toggle = e.target;
      }

      if (toggle) {
        if (toggle.disabled) return;
        var sizes = getActiveSizeFilters();
        if (!sizes.length) {
          toggle.checked = false;
          saveInstock(false);
          syncInstockUI();
          return;
        }
        saveInstock(!!toggle.checked);
        qsa('[data-ymi-instock-toggle]').forEach(function (other) {
          if (other !== toggle) other.checked = toggle.checked;
        });
        syncInstockUI();
        return;
      }

      if (e.target.closest && e.target.closest('.filter-form')) {
        scheduleSync(300);
        scheduleSync(900);
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.tag--remove, .filter-reset, .form_clear, .ymi-filter-chips a')) {
        scheduleSync(300);
        scheduleSync(900);
      }

      var instockLabel = e.target.closest && e.target.closest('.ymi-my-size__instock');
      if (!instockLabel) return;

      var input = qs('[data-ymi-instock-toggle]', instockLabel);
      if (!input || input.disabled) return;

      if (e.target !== input) {
        e.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    window.addEventListener('popstate', function () {
      scheduleSync(100);
    });

    document.addEventListener('collection:reloaded', function () {
      scheduleSync(50);
      scheduleSync(400);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Sticky filter bar                                                   */
  /* ------------------------------------------------------------------ */
  function getStickyTop() {
    var banner = document.getElementById('shopify-section-birthday-banner');
    if (banner && isVisible(banner)) {
      return Math.max(0, Math.round(banner.getBoundingClientRect().bottom));
    }

    var headerEl =
      qs('.active-header [data-section-type="header"]') ||
      qs('.active-header .site-header') ||
      qs('.active-header');

    if (headerEl && isVisible(headerEl)) {
      return Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
    }

    var stack = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--mobile-sticky-stack')
    );
    return isNaN(stack) ? 0 : Math.round(stack);
  }

  function ensureSpacer() {
    if (!bar || !bar.parentNode) return null;
    if (spacer && spacer.parentNode) return spacer;
    spacer = document.createElement('div');
    spacer.className = 'ymi-filter-bar-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    bar.parentNode.insertBefore(spacer, bar);
    return spacer;
  }

  function unpinBar() {
    if (!bar || !fixed) return;
    bar.classList.remove('ymi-filter-bar--fixed');
    bar.style.top = '';
    bar.style.width = '';
    bar.style.left = '';
    if (spacer) {
      spacer.classList.remove('is-active');
      spacer.style.height = '';
    }
    fixed = false;
  }

  function pinBar(top) {
    if (!bar) return;
    var height = Math.ceil(bar.getBoundingClientRect().height);
    var sp = ensureSpacer();
    if (sp) {
      sp.style.height = height + 'px';
      sp.classList.add('is-active');
    }
    bar.classList.add('ymi-filter-bar--fixed');
    bar.style.top = top + 'px';
    fixed = true;
  }

  function updateStickyBar() {
    bar = qs('.collection-sidebar .filters-container_mobile') || qs('.filters-container_mobile');

    if (!bar || !isMobile() || isDrawerOpen()) {
      unpinBar();
      document.documentElement.style.removeProperty('--collection-sticky-top');
      return;
    }

    var top = getStickyTop();
    document.documentElement.style.setProperty('--collection-sticky-top', top + 'px');

    if (fixed) {
      if (spacer && spacer.classList.contains('is-active')) {
        naturalTop = spacer.getBoundingClientRect().top + window.scrollY;
      }
    } else {
      naturalTop = bar.getBoundingClientRect().top + window.scrollY;
    }

    if (window.scrollY + top >= naturalTop - 1) {
      pinBar(top);
    } else {
      unpinBar();
    }
  }

  function preventDrawerCloseOnInnerClick() {
    var drawer = document.getElementById('FilterDrawer');
    if (!drawer || drawer.getAttribute('data-ymi-drawer-guard') === '1') return;
    drawer.setAttribute('data-ymi-drawer-guard', '1');

    ['click', 'touchend', 'mousedown'].forEach(function (evtName) {
      drawer.addEventListener(evtName, function (e) {
        if (e.target.closest('.js-drawer-close, .form_close, .drawer__close')) return;
        e.stopPropagation();
      });
    });
  }

  function init() {
    initInstockInMySize();
    preventDrawerCloseOnInnerClick();
    updateStickyBar();

    var ajaxScheduled = false;
    function onAjaxDomChange() {
      if (ajaxScheduled) return;
      ajaxScheduled = true;
      requestAnimationFrame(function () {
        ajaxScheduled = false;
        scheduleSync(50);
        scheduleSync(400);
        scheduleSync(1000);
        preventDrawerCloseOnInnerClick();
        updateStickyBar();
      });
    }

    window.addEventListener('scroll', function () {
      requestAnimationFrame(updateStickyBar);
    }, { passive: true });
    window.addEventListener('resize', function () {
      updateStickyBar();
      scheduleSync(100);
    }, { passive: true });
    window.addEventListener('orientationchange', function () {
      updateStickyBar();
      scheduleSync(100);
    });
    document.addEventListener('header:toggle', updateStickyBar);
    document.addEventListener('mobile-header:sticky-change', updateStickyBar);

    if (typeof MutationObserver !== 'undefined') {
      var ajaxRoot = document.getElementById('CollectionAjaxContent');
      if (ajaxRoot) {
        var mo = new MutationObserver(onAjaxDomChange);
        mo.observe(ajaxRoot, { childList: true, subtree: false });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();